import { render, staticRenderFns } from "./ManifestOutside.vue?vue&type=template&id=456532d6&"
import script from "./ManifestOutside.vue?vue&type=script&lang=js&"
export * from "./ManifestOutside.vue?vue&type=script&lang=js&"
import style0 from "./ManifestOutside.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports